import { Table } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import TaskPayRowsTableBody from './TaskPayRowsTableBody';
import type { TaskPayReportItemType } from '@econtractor/types';

interface TaskPayRowsTableProps {
    rows: TaskPayReportItemType[];
}

const TaskPayRowsTable = ({ rows }: TaskPayRowsTableProps) => {
    const { t } = useTranslation(['Reports']);

    return (
        <div className="crm-table-wrap">
            <Table className="ObjectRepTable TaskPayRowsTable table-hover mb-0">
                <thead>
                    <tr className="bg-light">
                        <td className="head-name">{t('tasksFields.task')}</td>
                        <td className="head-type">{t('tasksFields.type')}</td>
                        <td className="head-status">{t('tasksFields.status')}</td>
                        <td className="head-date">{t('tasksFields.term')}</td>
                        <td className="head-binding">{t('tasksFields.binding')}</td>
                        <td className="text-end head-income">{t('tasksFields.income')}</td>
                    </tr>
                </thead>
                <TaskPayRowsTableBody rows={rows} />
            </Table>
        </div>
    );
};

export default TaskPayRowsTable;
